import { useEffect, useState } from 'react'
import { StoreCustomerType } from 'types/storeCustomer'
import { fetchStoreCustomer } from 'repos/storeCustomer'
import { FirebaseDocRefType } from 'firebase/index'

const useFetchStoreCustomer = (storeRef: FirebaseDocRefType, userId: string) => {
  const [storeCustomer, setStoreCustomer] = useState<StoreCustomerType | undefined>(undefined)

  useEffect(() => {
    if (!userId) return
    ;(async () => {
      const result = await fetchStoreCustomer(storeRef, userId)
      setStoreCustomer(result)
    })()
  }, [storeRef, userId])

  return {
    storeCustomer,
    setStoreCustomer,
  }
}

export default useFetchStoreCustomer
